/**
 *
 * @param dispatch
 */

export function getActivityLogData(_ref) {
  var dispatch = _ref.dispatch;
  dispatch('api', {
    url: 'activity-logs',
    commitAfter: 'activityLog/SET_ACTIVITY_LOG_DATA',
    wait: 'get-activity-data'
  }, {
    root: true
  });
}

/**
 *
 * @param commit
 * @param data
 */
export function storeActivityLogData(_ref2, data) {
  var commit = _ref2.commit;
  commit('SET_ACTIVITY_LOG_DATA', data);
}